import type { LiHTMLAttributes, ReactNode } from "react"
import classnames from "classnames"
import type { ModelSelectorListOption } from "./types"

export interface ModelSelectorOptionProps {
  option: ModelSelectorListOption
  label?: ReactNode
  disabled?: boolean
}

// Rendered as the Autocomplete option element (an <li>). MUI v9's MenuItem now
// requires MenuListContext, so it can no longer be used outside a Menu/MenuList.
// Keep `value` on the <li> (mirroring the old <MenuItem value={option.id}>) —
// the integration suite selects a specific option by its DOM value attribute.
export function ModelSelectorOption({
  option,
  label,
  disabled,
  className,
  ...liProps
}: ModelSelectorOptionProps & LiHTMLAttributes<HTMLLIElement>) {
  return (
    <li
      {...liProps}
      value={option.id}
      aria-disabled={disabled || undefined}
      className={classnames(className, { "Mui-disabled": disabled })}
    >
      <span className="model-selector-option-label">
        {label ?? option.name}
      </span>
    </li>
  )
}
